import {
  RdnCaseDetailQuery,
  RdnCasesListQuery,
  GetCaseStatusChangeQuery,
  GetCaseUserActivitiesQuery,
} from '@rapid-recovery-agency-inc/insightt-graphql';
import { normalizeMissedRepossessions } from './utils';

export enum CasesEvent {
  CASE_ARCHIVED_FROM_LIST = 'CASE_ARCHIVED_FROM_LIST',
  CASE_ASSIGN_USERS = 'CASE_ASSIGN_USERS',
}
export enum CasesActions {
  SEARCH_CASES = 'CASES/SEARCH_CASES',
  FETCH_CASE_DETAIL = 'CASES/FETCH_CASE_DETAIL',
  FETCH_CASE_STATUS_CHANGES = 'CASES/FETCH_CASE_STATUS_CHANGES',
  FETCH_CASE_RDN_ACTIVITY = 'CASES/FETCH_CASE_RDN_ACTIVITY',
}

export interface SearchCasesState {
  isSearching: boolean;
  cases: RdnCasesListQuery['rDNCases'];
  searchText: string;
}

export interface SearchCasesInput {
  searchText: string;
  signal: AbortSignal | undefined;
}
export type SearchCasesResponse = {
  cases: SearchCasesState['cases'];
  isSearching: SearchCasesState['isSearching'];
};

export interface CaseDetailState {
  isLoading: boolean;
  case?: RdnCaseDetailQuery['rDNCase'];
  caseMissedRepossessions?: ReturnType<typeof normalizeMissedRepossessions>[] | null;
  caseStatusChanges: {
    data: GetCaseStatusChangeQuery['rDNCaseEvents'];
    isLoading: boolean;
    count: number;
  };
  rdnActivity: {
    data: GetCaseUserActivitiesQuery['userActivities'];
    isLoading: boolean;
    count: number;
  };
}
export type CaseDetailInput = string;
export type CaseDetailResponse = {
  case: CaseDetailState['case'];
  caseMissedRepossessions: CaseDetailState['caseMissedRepossessions'];
};

export interface FetchCaseDetailStatusChangeOutput {
  data: GetCaseStatusChangeQuery['rDNCaseEvents'];
  count: number;
}

export interface FetchCaseDetailStatusChangeInput {
  caseId: string;
  page: number;
}

export interface FetchCaseDetailRdnActivityOutput {
  data: GetCaseUserActivitiesQuery['userActivities'];
  count: number;
}

export interface FetchCaseDetailRdnActivityInput {
  caseId: string;
  page: number;
}
